/** @format */

import api from "../../../utils/api";
import { referenceService } from "../constant";
import {
  getCache,
  setCache,
  removeCacheByPrefix,
} from "../../../utils/cacheHelper";

const basePath = `${referenceService}`;

/** get Penggunaan Bos */
export const getPenggunaanBos = async () => {
  const cached = getCache("penggunaan-bos");
  if (cached) return cached;

  const response = await api.get(`${basePath}/penggunaan-bos`, {
    params: {
      activated: 1,
    },
  });
  const data = response?.data?.return;
  if (data) setCache("penggunaan-bos", data);
  return data;
};

/** Post Penggunaan Bos */
export const postPenggunaanBos = async (params: any) => {
  const response = await api.post(`${basePath}/penggunaan-bos`, params, {
    headers: { "Content-Type": "application/json" },
  });
  removeCacheByPrefix("penggunaan-bos");
  return response?.data?.return;
};

/** Delete Penggunaan Bos */
export const deletePenggunaanBos = async (params: any) => {
  const response = await api.delete(`${basePath}/penggunaan-bos/${params}`);
  removeCacheByPrefix("penggunaan-bos");
  return response?.data?.return;
};
